/* unplugin-vue-components disabled */import script from "./Lxwm.vue?vue&type=script&lang=ts&setup=true"
export * from "./Lxwm.vue?vue&type=script&lang=ts&setup=true"

import "./Lxwm.vue?vue&type=style&index=0&id=36615eee&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36615eee"]])

export default __exports__